import type { Translation } from '@/i18n/dictionary'
import type { WrittenPage } from '@/content/sections'

/**
 * `/tr/newsletter`. The archive list itself needs no translation — each card
 * takes its words from the issue's own page, so a Turkish issue page translates
 * its own card and an English-only issue shows its English title, which is this
 * dictionary's ordinary rule rather than a gap.
 *
 * No route here: `content/pages/newsletter.ts` declares it once for every
 * locale. This file is copy only.
 */
export const newsletter: Translation<WrittenPage> = {
  navLabel: 'Bülten',
  title: 'Digitopia Bülteni',
  description:
    'Ayda bir e-posta: digital ve AI transformation’da ne görüyoruz, veri ne söylüyor, biz ne yapardık. Tüm sayılar burada.',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'Bülten',
      headline: 'Ayda bir, ne görüyorsak.',
      sub: 'Tek e-posta. Başkalarının linklerinden derleme değil.',
      body: [
        'Her sayı, digital ve AI transformation’da olan tek bir şeyi alıp verinin ne gösterdiğini ve bizim ne yapacağımızı yazıyor — işi yapan ekip yazıyor, marketing takvimi değil.',
        'Ayda bir gidiyor, tek bir e-posta, ve unsubscribe linki tek tıkla çalışıyor. Sayfanın altından kaydolabilirsiniz.',
      ],
    },
    {
      kind: 'issues',
      heading: 'Tüm sayılar',
      empty:
        'İlk sayı yazılıyor. Sayfanın altından kaydolun; ilk alacağınız şey o olsun. Sonraki her sayı da okunmak üzere burada kalıyor.',
    },
  ],
}
